import HTTPClient from './http-client';

const END_POINT = '/historical';

const loadSiprecDailyEstimated = async (payload) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  const headers = { headers: { "Content-Type": "application/json" } };
  return api.post(`${END_POINT}/siprecdaily`, payload, headers);
}

const loadSiprecAccumDaily = async (payload) =>{
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  const headers = { headers: { "Content-Type": "application/json" } };
  return api.post(`${END_POINT}/siprecaccumdaily`, payload, headers);
}

export {
  loadSiprecDailyEstimated, loadSiprecAccumDaily
}
